import { Component, Input, OnInit } from '@angular/core';
import { ErrorsReports } from 'src/app/model/installation/errors-reports.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

@Component({
  selector: 'app-installation-error-reports',
  templateUrl: './installation-error-reports.component.html',
  styleUrls: ['./installation-error-reports.component.scss']
})
export class InstallationErrorReportsComponent implements OnInit {

  @Input() installation: any;
  constructor(private service: InstallationsService) { }

  public errors! : ErrorsReports;
  public pre : any = 0;

  ngOnInit(): void {
    if (this.installation) {
      this.service.getErrorsData(this.installation.id_installation,this.pre).subscribe((errors) => {
        this.errors = errors;
      })
    }
  }

  public pageChange(e: any)  {
    this.pre = e;
    this.service.getErrorsData(this.installation.id_installation,this.pre).subscribe((errors) => {
      this.errors = errors;
    });
  }

}
